$.fn.ScrollEffect_Column = function(grid) {
  let self = this
  self.total_height = 0

  self.calculate_height = function() {
    if (!$.mlmi.mobile.matchesMedia()) {
      if (grid.type == 1) {
        // self.find('.card-team__description').last().css('min-height', '0px')
        self.each(function() {
          if ($(this).find('.card-team__image').length) {
            self.total_height += $(this).outerHeight(true)
          }
        })
        let last_card = self.find('.card-team__image').last().closest('.card-team'),
        last_item = last_card.closest('.grid__item')
        self.total_height -= (last_item.height() - (last_card.find('.card-team__title').outerHeight(true) + last_card.find('.card-team__description').outerHeight(true)))
        grid.calculate_max_height()
      } else if (grid.type == 2) {
        // self.each(function() {
        //   self.total_height += $(this).outerHeight(true)
        // })
        // grid.calculate_max_height()
      }
    } else {
      // self.find('.card-team__description').last().css('min-height', '')
    }
  }

  self.reset = function() {
    self.each(function() {
      $(this).css('transform', '')
    })
  }

  return function() {
    $(window).on('load orientationchange resize', self.calculate_height)
    self.calculate_height()
    return self
  }()
}

$.fn.ScrollEffect = function() {
  let self = this

  if (self.data('scroll-effect')) {
    return self.data('scroll-effect')
  }

  self.type = 1
  self.panel = self.closest('.panel').Panel()
  self.active = false
  self.columns = []
  self.highest = undefined

  self.initialize_columns = function() {
    if (self.hasClass('grid--style--portfolio')) {
      self.type = 2
      self.find('.grid__item').each(function() {
        let coordX = parseFloat($(this).css('left'))
        if (coordX < 5) {
          if (!self.columns.length) {
            self.columns = [[], [], [], []]
          }
          self.columns[2].push($(this).get(0))
        } else if (coordX < self.width() / 2) {
          self.columns[1].push($(this).get(0))
        } else {
          self.columns[0].push($(this).get(0))
        }
      })
      self.columns[0] = $(self.columns[0]).ScrollEffect_Column(self)
      self.columns[1] = $(self.columns[1]).ScrollEffect_Column(self)
      self.columns[2] = $(self.columns[2]).ScrollEffect_Column(self)
      self.columns[3] = $(self.columns[3]).ScrollEffect_Column(self)
    } else {
      self.type = 1
      self.columns[0] = self.find('.grid__item:nth-child(4n):has(.card-team__image)').ScrollEffect_Column(self),
      self.columns[1] = self.find('.grid__item:nth-child(4n-1):has(.card-team__image)').ScrollEffect_Column(self),
      self.columns[2] = self.find('.grid__item:nth-child(4n-2):has(.card-team__image)').ScrollEffect_Column(self),
      self.columns[3] = self.find('.grid__item:nth-child(4n-3):has(.card-team__image)').ScrollEffect_Column(self)
    }
    self.active = true
  }

  self.check_active = function() {
    if (!$.mlmi.mobile.matchesMedia() && self.panel.is_expanded()) {
      setTimeout(self.initialize_columns, 100)
      self.panel.scroller.scrollers[0].scrollEvents.add(self.scrolled)
      self.scrolled()
    } else {
      self.active = false
      self.columns = []
      self.panel.scroller.scrollers[0].scrollEvents.removeCallback(self.scrolled)
    }
  }

  self.reset_columns = function() {
    self.columns.forEach(function(column) {
      column.reset()
    })
  }

  self.scrolled = function(top) {
    if (self.type == 1) {
      top -= (self.offset().top + top)
    }
    if (self.active) {
      let percent = Math.max(0, Math.min(1, top / (self.highest.total_height - $(window).height())))
      if (percent >= 0 && percent <= 1) {
        self.columns.forEach(function(column) {
          if (column != self.highest) {
            let difference = self.highest.total_height - column.total_height
            column.css({
              transform: 'translateY(' + (difference * percent) + 'px)',
            })
          }
        })
      }
    } else {
      self.reset_columns()
    }
  }

  self.calculate_max_height = function() {
    self.highest = undefined
    self.columns.forEach(function(column) {
      if (self.highest == undefined || column.total_height > self.highest.total_height) {
        self.highest = column
      }
    })
  }

  return function() {
    $.mlmi.panels.on('transition_ended', self.check_active)
    $('body').on('intro_played', function() {
      setTimeout(self.check_active, 850)
    })
    $(window).on('resize orientationchange load', self.check_active)
    self.check_active()
    self.data('scroll-effect', self)
    return self
  }()
}
